import React from 'react';
import { useSelector } from 'react-redux';
import ImageBanner from '../../shared/components/image-banner';

import withPageComponents from '../../page/components/with-page-components';
import { Hyperlink } from '../../shared/components/hyperlink';

import './css/search-product-banner.less';

const SearchBanner = props => {
    const { hawksearchResults, trackCustomMetric } = props || {};
    const hawksearchSearchData = hawksearchResults && hawksearchResults.products;
    const isMobile = useSelector(
        state => state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints.visId === 'xsmall'///['xsmall', 'small'].includes(state.ui.customBreakpoints.visId) //customBreakpoints.srp === 'mobile'
    );

    const { Merchandising } = hawksearchSearchData || {};
    const { Items } = Merchandising || {};

    return Array.isArray(Items)
        ? Items.reduce((allBanners, banner, idx) => {
              try {
                  let {
                      Zone,
                      Title,
                      ContentType,
                      ImageUrl,
                      AltTag,
                      ForwardUrl,
                      Output,
                      Height,
                      Width,
                      WidgetArgs,
                      IsMobile,
                      MobileContentType,
                      MobileImageUrl,
                      MobileOutput,
                      MobileWidgetArgs,
                      IsTrackingEnabled,
                      MobileIsTrackingEnabled,
                      Target,
                      MobileTarget,
                      MobileAltTag,
                      MobileForwardUrl,
                      MobileWidth,
                      MobileHeight,
                      Trigger,
                      BannerId,
                      CampaignId,
                      gtmActions,
                  } = banner;

                  if(isMobile && !IsMobile){
                    return allBanners;
                  }

                  const onBannerClick = () => {
                      try {
                          let { gtmId } = gtmActions.get('ctaClick');
                          let params = promotionsMap[gtmId];
                          params && trackCustomMetric('promotionClick', { ...params, promoClickType: 'shop' });
                      } catch (e) {}
                  };

                  let imageUrl = (isMobile && MobileImageUrl) || ImageUrl;
                  if (!imageUrl || imageUrl.length === 0) {
                      return allBanners;
                  }
                  let bannerProps = {
                      image: {
                          url: {
                              desktop: imageUrl,
                              mobile: imageUrl,
                          },
                          alt: (isMobile && MobileAltTag) || AltTag,
                      },
                      contentAlignment: 'center',
                      type: 'hero',
                      className: 'srp-product-banner',
                      onBannerClick,
                  };
                  let style = {
                      height: (isMobile && MobileHeight) || Height || null,
                      width: (isMobile && MobileWidth) || Width || null,
                  };

                  let anchorHref = isMobile ? MobileForwardUrl || ForwardUrl : ForwardUrl;
                  let target = isMobile ? MobileTarget || Target : Target;

                  let anchorProps = {
                      to: anchorHref,
                      target,
                  };

                  allBanners.push(
                      <Hyperlink key={idx} className="hawksearch-banner" {...anchorProps} style={style}>
                          <ImageBanner {...bannerProps} offset />
                      </Hyperlink>
                  );
              } catch (e) {}
              return allBanners;
          }, [])
        : null;
};

export default withPageComponents(SearchBanner, { components: ['hawksearchResults'] });
